import { Suspense, lazy } from 'react';

const LazyDevTools = lazy(() => import('@tanstack/react-query-devtools').then(({ ReactQueryDevtools }) => ({ default: ReactQueryDevtools })));

export function DevTools() {
  const showDevTools = !(window as any).Cypress && (process.env.NODE_ENV === 'development' || localStorage.getItem('devTools') === 'true');

  return showDevTools ? (
    <Suspense fallback={null}>
      <LazyDevTools initialIsOpen={false} position="bottom-right" />
    </Suspense>
  ) : null;
}
